import { defineMessages } from 'react-intl-next';

export const messages: {
    arrowDown: {
        defaultMessage: string;
        description: string;
        id: string;
    }; arrowUp: {
        defaultMessage: string;
        description: string;
        id: string;
    }; moveDown: {
        defaultMessage: string;
        description: string;
        id: string;
    }; moveUp: {
        defaultMessage: string;
        description: string;
        id: string;
    }; reorder: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	moveUp: {
		id: 'company-hub.company-hub-common.link-cards.cards-area-container-components.draggable-card-container.move.up.label',
		defaultMessage: 'Move up',
		description: 'Label of drag and drop menu item for moving card one placement up',
	},
	moveDown: {
		id: 'company-hub.company-hub-common.link-cards.cards-area-container-components.draggable-card-container.move.down.label',
		defaultMessage: 'Move down',
		description: 'Label of drag and drop menu item for moving card one placement down',
	},
	arrowUp: {
		id: 'company-hub.company-hub-common.link-cards.cards-area-container-components.draggable-card-container.arrow.up',
		defaultMessage: 'up',
		description: 'Icon label of drag and drop menu item for moving card one placement up',
	},
	arrowDown: {
		id: 'company-hub.company-hub-common.link-cards.cards-area-container-components.draggable-card-container.arrow.down',
		defaultMessage: 'down',
		description: 'Icon label of drag and drop menu item for moving card one placement down',
	},
	reorder: {
		id: 'company-hub.company-hub-common.link-cards.cards-area-container-components.draggable-card-container.reorder',
		defaultMessage: 'reorder',
		description: 'Label of drag handle button shown on a card to reorder the card by dragging it up or down in the list',
	},
});
